import { render, staticRenderFns } from "./adminNews.vue?vue&type=template&id=567ba814&scoped=true&"
import script from "./adminNews.vue?vue&type=script&lang=js&"
export * from "./adminNews.vue?vue&type=script&lang=js&"
import style0 from "./adminNews.vue?vue&type=style&index=0&id=567ba814&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567ba814",
  null
  
)

export default component.exports